import { UserState } from './user.state';

import * as user from './user.actions';

export const initialState: UserState = {
	name: 			'',
	checking: 		true,
	neverLogged: 	true,
	userId: 0,
	username: '',
	password: '',
	roles: [],
	rolesId: [],
	surname: '',
	filiali: [],
	email: '',
	active: false,
	authorized: false,
	creationDate: '',
};

export function userReducer(state = initialState, action: user.Actions): UserState {

	switch (action.type) {

		//Devo controllare se la sessione è autenticata
		case user.CHECKING:
			return {
				...state,
				checking: 	true
			};

		//La sessione è autenticata
		case user.CHECKING_SUCCESS:
			return {
				...state,
				name: 			action.payload.name,
				logged: 		true,
				checking: 		false,
				neverLogged: 	false
			};

		//La sessione non è autenticata
		case user.CHECKING_FAIL:
			return {
				...state,
				name: 			'',
				logged: 		false,
				checking: 		false
			};

		// utente loggato
		case user.LOGIN_DONE: 
			return {
				...state,
				name: action.payload.name,
				checking: false,
				neverLogged: false,
				userId: action.payload.userId,
				username: action.payload.username,
				password: action.payload.password,				
				roles: action.payload.roles,
				surname: action.payload.surname,
				filiali: action.payload.filiali,
				email: action.payload.email,
				active: action.payload.active,
				authorized: action.payload.authorized,
				creationDate: action.payload.creationDate,				
			};

		default:
			return state;
	}
}
